import { boot } from './boot';

boot();
